import { useQuery } from '@tanstack/react-query';

import TechnicianService from '../../services/TechnicianService';

export enum TECHNICIAN_QUERY_KEYS {
  GET_TECHNICIAN = 'get-technician',
}

const technicianService = new TechnicianService();

export const useGetTechnicianQuery = (ticketHashId: string) => {
  const { data: technician } = useQuery({
    queryKey: [TECHNICIAN_QUERY_KEYS.GET_TECHNICIAN, ticketHashId],
    queryFn: () => technicianService.getTechnician(ticketHashId),
  });

  return {
    technician,
  };
};
